import { Chip, styled } from '@mui/material';
import Iconify from 'src/components/iconify';

const StyledChip = styled(Chip)(({ theme }) => ({
  borderRadius: theme.spacing(1),
  height: 'unset',
  padding: theme.spacing(0.75, 1),
  pointerEvents: 'none',
  fontWeight: 700,
  lineHeight: 1,
  background: theme.palette.background.paper,
  color: theme.palette.text.secondary,
  width: '100%',
  '& .MuiChip-label': {
    paddingRight: 0,
  },
  '& .MuiChip-icon': {
    marginLeft: 0,
    color: theme.palette.primary.main,
    width: 16,
    height: 16,
    '& path': {
      strokeWidth: 3,
    },
  },
}));

export const ParticipantsCount = ({ count }: { count: number }) => {
  return (
    <StyledChip
      label={count}
      variant="soft"
      icon={<Iconify icon="tabler:users" />}
    />
  );
};
